// Dependencies
require("webstrap/scaffolding");

// Styles
require("./grid.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/grid/index.js
 ** module id = 128
 ** module chunks = 0 1
 **/